"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformerItemLabels = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Flex_1 = __importDefault(require("@atg/icf-react-components/components/Flex"));
var Text_1 = __importDefault(require("@atg/icf-react-components/components/Text"));
var FeatureFlags_1 = require("icf-search-client-shared/lib/FeatureFlags");
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var usePerformerItemLabelsStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    labelsWrapper: {
        fontSize: "8px",
        fontWeight: 500,
        lineHeight: "10px",
        position: "absolute",
        insetInlineEnd: "4px",
        textTransform: "uppercase",
        top: "4px",
        zIndex: 1,
        textAlign: "center",
    },
    isNewLabel: {
        backgroundColor: theme.colors.primary,
        color: theme.colors.textOnDark,
        padding: "2px 4px",
        marginBottom: "4px",
    },
    // Some labels have hard coded background colors on purpose
    // and will be the same on all themes and skins.
    hasVibeLabel: {
        // background-color had an invalid value with styled-components
        // `background-color: #d222de};`
        backgroundColor: "#d222de",
        color: theme.colors.textOnDark,
        padding: "2px 4px",
        marginBottom: "4px",
    },
    hasPhoneLabel: {
        // background-color had an invalid value with styled-components
        // `background-color: #6f6f6f};`
        backgroundColor: "#6f6f6f",
        color: theme.colors.textOnDark,
        padding: "2px 4px",
        marginBottom: "4px",
    },
    specialShowLabel: {
        backgroundColor: "#7F44F7",
        color: theme.colors.textOnDark,
        padding: "2px 4px",
    },
    goldShowLabel: {
        padding: "3px",
    },
}); });
var PerformerItemLabels = function (props) {
    var _a = __read((0, Ioc_1.useContexts)(Contexts_1.ITranslationServiceContext, Contexts_1.ISearchSkinConfigContext), 2), translate = _a[0].translate, skinConfig = _a[1];
    var isNew = props.isNew, showType = props.showType, hasVibe = props.hasVibe, hasVoip = props.hasVoip;
    var classes = usePerformerItemLabelsStyles();
    // Only render if at least 1 label should be shown.
    if (!isNew && !showType && !hasVoip && !hasVibe) {
        return null;
    }
    var showNew = isNew && (0, FeatureFlags_1.isFeatureFlagEnabled)("enable_search_new_model_labels", skinConfig);
    var showVibe = hasVibe && (0, FeatureFlags_1.isFeatureFlagEnabled)("enable_search_has_vibe_labels", skinConfig);
    var showVoip = hasVoip && (0, FeatureFlags_1.isFeatureFlagEnabled)("enable_search_has_voip_labels", skinConfig);
    return ((0, jsx_runtime_1.jsxs)("div", { className: classes.labelsWrapper, children: [showNew && ((0, jsx_runtime_1.jsx)("div", { className: classes.isNewLabel, "data-ta-locator": "PerformerItemLabels-newModel", children: translate("search.new_model") })), showVibe && ((0, jsx_runtime_1.jsx)("div", { className: classes.hasVibeLabel, "data-ta-locator": "PerformerItemLabels-hasVibe", children: translate("search.has_vibe") })), showVoip && ((0, jsx_runtime_1.jsx)("div", { className: classes.hasPhoneLabel, "data-ta-locator": "PerformerItemLabels-hasVoip", children: translate("search.has_voip") })), showType === "goldShow" && ((0, jsx_runtime_1.jsx)("div", { className: classes.goldShowLabel, children: (0, jsx_runtime_1.jsx)(Flex_1.default, { background: "gold", padding: "3 5", borderRadius: 4, children: (0, jsx_runtime_1.jsx)(Text_1.default, { fontSize: 11, color: "textOnLight", lineHeight: 1, letterSpacing: 0, children: translate("search.goldshow") }) }) })), showType === "specialShow" && (0, jsx_runtime_1.jsx)("div", { className: classes.specialShowLabel, children: translate("search.specialshow") })] }));
};
exports.PerformerItemLabels = PerformerItemLabels;
//# sourceMappingURL=PerformerItemLabels.js.map